/**
 * 当执行这个函数时,会反回一个新对象,新对象把第一个参数ob在path代表的路径上的值设为了第三个参数value.
 * @param obj 复杂对象ob
 * @param path 字符串数据path
 * @param value 任意类型的值value
 * @returns
 */
export function set<T = any>(
  obj: Array<any> | { [pro: string]: any },
  path: (string | number)[],
  value: any,
): T {
  const newObj = Array.isArray(obj) ? [...obj] : { ...obj };

  const pathArray = path;

  let currentObj: any = newObj;
  for (let i = 0; i < pathArray.length - 1; i++) {
    const key = pathArray[i];

    if (!(key in currentObj)) {
      currentObj[key] = {};
    }

    currentObj = currentObj[key];
  }

  currentObj[pathArray[pathArray.length - 1]] = value;

  return newObj as T;
}
